export default function OurStory() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-[#2C2C2C] mb-16 text-center">
          Our Story
        </h2>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="w-full h-[500px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/5dddf9ca4bfe1a373ed643019c5731ad.jpg"
              alt="Multifamily construction renovation project"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              Deer Point Contracting was founded by Matt and Christina Crance with a clear mission: deliver full-service construction with the accountability and personal attention that owners and investors deserve.
            </p>
            <p>
              Headquartered in Virginia, Deer Point provides comprehensive construction services to owners, investors, managers, and general contractors throughout the Mid-Atlantic region and beyond. Our teams are well versed in both exterior and interior scopes of work for multifamily and commercial projects. From large-scale apartment renovations and affordable housing to storefront installations and government contracting, we deliver the construction expertise, staff, and building materials to accomplish your project.
            </p>
            <p>
              Since 2003, our leadership team has supplied, built, and renovated market-rate and affordable housing projects throughout the United States, both urban and rural, completing over 3,600 units and $225 million in contract work. Today, Deer Point is expanding its capabilities into senior living and healthcare facility renovations, bringing the same quality and reliability our clients have come to expect into an underserved market across the Mid-Atlantic and Southeast.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}